module.exports = __webpack_public_path__ + "static/img/Recommend.25ff913d.png";